var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.661,
    height: 15.826,
    viewBox: "0 0 12.661 15.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Dictionary",
    d: "M20.067,17.848a.593.593,0,0,0,.593-.593V5.78A1.783,1.783,0,0,0,18.88,4H9.78A1.783,1.783,0,0,0,8,5.78V18.046a1.783,1.783,0,0,0,1.78,1.78H20.067a.593.593,0,0,0,0-1.187H9.78a.594.594,0,0,1-.593-.593v-.2ZM11.759,7.957H16.9a.593.593,0,1,1,0,1.187H11.759a.593.593,0,1,1,0-1.187Z",
    transform: "translate(-8 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionary);
export default __webpack_public_path__ + "static/media/Dictionary.41f67701b0add7dd2d95f558fd28ad2e.svg";
export { ForwardRef as ReactComponent };